import styled from "@emotion/styled";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 500;

  margin-bottom: 24px;

  color: ${({ labelColor }) => labelColor};
`;

const List = styled.ul`
  display: flex;
  gap: 20px;
`;

const Item = styled.li`
  display: flex;
  gap: 10px;
`;

const IconBox = styled.span`
  display: flex;
  align-items: center;
  color: ${({ iconColor }) => iconColor};
`;

const Text = styled.span`
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 16px;
  }
`;

export { Wrapper, List, Item, IconBox, Text };
